'use strict';

/** @type {import('./isObject')} */
module.exports = function isObject(x) {
	return !!x && (typeof x === 'function' || typeof x === 'object');
};



//////////////////
// WEBPACK FOOTER
// ./~/es-object-atoms/isObject.js
// module id = ZMEC
// module chunks = 0